import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { PerfilCorporativoVO } from '../shared/model/perfil-corporativo-vo.model';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class PerfilCorporativoService {

  private readonly service = '/sepin-backend/rest/proxy/perfil-corporativo';

  constructor(private readonly http: McticHttpClient) {
  }

  consultarPerfisPorUsuario(usuario: string): Observable<PerfilCorporativoVO[]> {
    return this.http.get<PerfilCorporativoVO[]>(`${this.service}/perfil/sistema/SEPIN/usuario/${usuario}`);
  }
}
